define('views/modules/member/member/edit/member-create-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // services
    'services/user',
    'services/i18n',
    'services/events/user-events',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/modules/profile/edit/account-info-edit-form',
    'views/modules/profile/edit/account-settings-edit-form',
    'views/modules/profile/edit/create-options-edit-form',
    'views/modules/profile/edit/personal-info-edit-form',
    'views/modules/member/member/member-lists-controller',
    'views/parts/alert/alert-list',
    'views/modules/member/group-panel',
    // modals
    'views/modules/member/member/modal/add-test-client-modal',
    // collections
    'collections/questionnaire/questionnaires',
    'collections/template/templates',
    // templates
    'text!templates/modules/profile/edit/profile-edit-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // services
    User, i18n,
    UserEvents,
    // views
    VForm,
    VMenuSaveAction,
    VAccountInfoEditForm,
    VAccountSettingsEditForm,
    VCreateOptionsEditForm,
    VPersonalInfoEditForm,
    VMemberListsController,
    VAlertList,
    VGroupPanel,
    // modals
    VAddTestClientModal,
    // collections
    CQuestionnaires,
    CTemplates,
    // templates
    TPersonalInfoEditContent
) {

    var VPersonalInfoEditContent = VForm.extend({
        template: TPersonalInfoEditContent,

        regions: {
            root: "#profile-edit-content",
            menu: ".menu-actions",
            alert: ".alert-list",
            forms: {
              account: ".account-info-edit-form",
              settings: ".account-settings-edit-form",
              options: ".create-options-edit-form",
              personal: ".personal-info-edit-form",
            },
        },

        initialize: function(options) {
            this.data = {
              defaultWelcomeMsg: "<p>Welcome! <br><br>Now that you've activated your account, you'll be able to use it to view your programs, log data and communicate with me!<br><br>The first thing you should do is learn how to use this software by <a href=\"https://intercom.help/totalcoaching/resources-for-clients\" target=\"_blank\">clicking on this link</a> (you can also access it by clicking on 'Help' in the left menu).<br><br>Have questions? Just click right on this message and we'll be in touch.</p>"
            };

            if (User.get('language') === "fr_CA" || User.get('language') === "fr_FR") {
                this.data.defaultWelcomeMsg = "<p>Bienvenue! <br><br>Maintenant que vous avez activé votre compte, vous pourrez l'utiliser pour consulter vos programmes, enregistrer des données et communiquer avec moi!<br><br>La première chose que je vous recommande est d'apprendre à utiliser ce logiciel en <a href=\"https://intercom.help/totalcoaching/ressources-pour-clients\" target=\"_blank\">cliquant sur ce lien</a><a href=\"https://intercom.help/totalcoaching/ressources-pour-clients\" target=\"_blank\"></a> (vous pouvez également y accéder en cliquant sur 'Aide 'dans le menu de gauche).<br><br>Des questions? Cliquez ici et discutons!</p>";
            }

            this.questionnaires = new CQuestionnaires();
            this.templates = new CTemplates();

            this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveButton,
                    saveText: 'supervisor:member-add-save-button',
                    radio: false,
                    tooltip: { container: this.regions.root, }
                }),
                forms: {
                  account: new VAccountInfoEditForm({ model: this.model }),
                  settings: new VAccountSettingsEditForm({ model: this.model }),
                  options: new VCreateOptionsEditForm({
                    model: this.model,
                    questionnaires: this.questionnaires,
                    templates: this.templates,
                    defaultWelcomeMsg: this.data.defaultWelcomeMsg,
                    selectedGroup: this.selectedGroup,
                    collection: this.collection,
                  }),
                  persona: new VPersonalInfoEditForm({ model: this.model })
                },
                alert: new VAlertList({
                    collection: new Backbone.Collection([])
                })
            };

            this.setDefaultValue(options);

            this.listenTo(this.model, { 'change': this.onModelChange })
                .listenTo(UserEvents, { 'group:manage': this.onDisplayGroupManager });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.fetchCollections();

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.forms.account, zone.forms.$account)
                //.assign(view.forms.settings, zone.forms.$settings)
                .assign(view.forms.options, zone.forms.$options)
                .assign(view.alert, zone.$alert);
                //.assign(view.forms.personal, zone.forms.$personal);

            this.conversation = this.view.forms.options.model.conversation;
            this.conversation.attributes.message = this.data.defaultWelcomeMsg;

            if (User.get('isHiddenFromClientsList') && U.getCookieByName('show_add_test_client_modal') === "") {
                this.showTestClientModal();
            }

            return this;
        },

        showTestClientModal: function() {
            var modal = new VAddTestClientModal({ callback: this.addTestClient.bind(this) });
            modal.render();
        },

        addTestClient: function() {
            User.save({ isHiddenFromClientsList: false }, { patch: true }).then(function() {
                UserEvents.testUserAdded(User, true);
                this.notifyTestUserHasBeenCreated();
                this.trigger('back');
            }.bind(this));
        },

        fetchCollections: function() {
            this.questionnaires.reset();
            this.questionnaires.state.pageSize = 0;
            this.questionnaires.fetch({ force: true });

            this.templates.reset();
            this.templates.fetch({ force: true });
        },

        setDefaultValue: function(options) {
          this.model.reset();

          if (this.conversation) {
            this.conversation.reset();
          }

          this.view.forms.options.selectedGroup = options.selectedGroup;
          //Set default value for the client based on coach values (i.e. Needed for conversion and others calculation)
          this.model.set('units', User.get("units"));
          this.model.set('language', User.get('language'));
          this.model.set('country', User.get('country'));
          this.model.set('province', User.get('province'));
          this.model.set('timezone', User.get('timezone'));
        },

        sendWelcomeMessage: function() {
            this.conversation.message = this.view.forms.options.view.form.welcomeMessage.getValue();
            this.conversation.set("message", this.view.forms.options.view.form.welcomeMessage.getValue());
            var conversation = this.conversation;
            conversation.setUser(this.model.id);

            if (conversation.attributes.message === '') {
              conversation.attributes.message = this.data.defaultWelcomeMsg;
            }

            conversation.attributes.sendNotification = false;

            conversation.save(conversation.attributes, {
              type: 'POST',
              context: this,
              silent: true,
              success: function() {
                  this.trigger('back');
              },
              error: function() {
                  // TODO : SHOW ERROR MESSAGE
                  // Message creation error should now block user's flow
                  this.trigger('back');
              },
            });
        },

        trimFields: function() {
          this.model.set('firstname', this.model.get('firstname').trim());
          this.model.set('lastname', this.model.get('lastname').trim());
          this.model.set('email', this.model.get('email').trim());
        },

        notifyTestUserHasBeenCreated: function() {
            Bootbox.alert({
                closeButton: false,
                title: i18n.t('success'),
                message: i18n.t('general:test-user-has-been-created')
            });
        },

        ////////////
        // events //
        ////////////
        onDisplayGroupManager: function() {
            var grpPanel = new VGroupPanel();
            this.trigger('panel:stack', grpPanel);
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSaveButton: function() {
            this.submit();
        },

        onSuccess: function() {
            this.trigger('member:created', this.model);
            this.sendWelcomeMessage();
        },

        onInvalid: function() {
            this.view.alert.reset();
            _.each(this.model.validationError, function(errors) {
                this.view.alert.addError(i18n.t(errors[0]));
            }, this);
        },

        onError: function(response) {
            if (response && response.responseJSON) {
                var errorCode = response.responseJSON.code,
                  message = response.responseJSON.message;

                if (errorCode) {
                    this.view.alert.reset();
                    this.view.alert.addError("api-messages:" + errorCode.replace(/_/g, '-'));
                }
            } else {
                if (response.responseText.indexOf("HAS_REACHED_MEMBER_LIMIT") > -1) {
                    this.view.alert.reset();
                    this.view.alert.addError("api-messages:HAS-REACHED-MEMBER-LIMIT");
                }
            }
        },

        onSubmit: function() {
            var model = this.model;

            this.trimFields();

            if (!model.isFromCanada()) {
                model.set('province', null);
            }
        }
    });

    return VPersonalInfoEditContent;
});

